<template>
  <el-container v-if="isAdmin">
    <el-aside width="250px">
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#304156"
        text-color="#fff"
        @select="changeSidebar"
        active-text-color="#4980ff">
        <!-- 一级菜单项 -->
        <el-submenu index="访客预约管理">
          <template #title>
            <span>设置</span>
          </template>
          <el-menu-item index="WangZhanInfo">
            <i class="el-icon-document"></i>
            <span slot="title">报餐基础设置</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="访客表单管理">
          <template #title>
            <span>用户管理</span>
          </template>
          <el-menu-item index="YongHu">
            <i class="el-icon-s-shop"></i>
            <span slot="title">用户组</span>
          </el-menu-item>
          <el-menu-item index="GuanLi">
            <i class="el-icon-chat-dot-square"></i>
            <span slot="title">管理组</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="GuiZe">
          <span slot="title">规则管理</span>
        </el-menu-item>
        <el-menu-item index="BuMen">
          <span slot="title">部门管理</span>
        </el-menu-item>
        <el-menu-item index="CaiDan">
          <span slot="title">本周菜单</span>
        </el-menu-item>
        <el-menu-item index="DingDan">
          <span slot="title">订单管理</span>
        </el-menu-item>
        <el-menu-item index="TongJi">
          <span slot="title">统计管理</span>
        </el-menu-item>
        <el-submenu index="核销管理">
          <template #title>
            <span>核销管理</span>
          </template>
          <el-menu-item index="KaiCan">
            <i class="el-icon-message-solid"></i>
            <span slot="title">开餐二维码</span>
          </el-menu-item>
          <el-menu-item index="HeXiao">
            <i class="el-icon-chat-dot-square"></i>
            <span slot="title">核销记录</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>小鹅科技-报餐系统</el-header>
      <el-main>
        <!-- 核心在这，这里是路由的出口 -->
        <router-view></router-view>
      </el-main>
      <!-- 底部区域 -->
      <el-footer>报餐系统 ©2025 Created by 小鹅科技</el-footer>
    </el-container>
  </el-container>
  <div v-else class="non-admin-message">
    <p>您不是管理员，只能使用手机端打开应用。</p>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      code: '',
      state: '',
      isAdmin: false, // 用户存储用户是否管理员
    };
  },

  mounted() {
    this.handleRedirect();
    this.getUserRole();
  },
  methods: {
    getUserRole() {
      this.$axios.get('/api/check_admin')
        .then(response => {
          console.log('admin', response.data);
          if (response.data.code === 0) {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
            this.$message.error('您不是管理员，只能使用手机端打开应用。');
          }
        })
        .catch(error => {
          console.error('Error getting user role:', error);
          this.$message.error('无法获取用户权限，请稍后再试。');
        });
    },

    handleRedirect() {
      this.code = this.$route.query.code;
      this.state = this.$route.query.state;
      // console.log(this.code);
// 
      if (this.code && this.state) {
        // console.log('Code:', this.code);
        // console.log('State:', this.state);

        // 可以在这里发送这些参数到后端
        axios.post('https://baocan.xiao-e.tech/api/redirect', { code: this.code, state: this.state })
          .then(response => {
            // console.log('Response:', response.data);
            // console.log('response.data.data:', response.data.data);
            // 将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
            const token = response.data.data;
            // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
            localStorage.setItem('token', token);
            // const token1 = localStorage.getItem('token');
            // console.log('token1', token1);
            this.getUserRole();
          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        console.error('Missing code or state parameter');
      }
    },

    changeSidebar(path) {
      // Check if the current path is different from the target path
      if (this.$route.path !== path) {
        this.$router.push(path); // Navigate to the new route
      }
    },
  }
};
</script>

<style scoped>
.el-aside__logo {
  height: 120px;
  background: url('@/assets/logo.jpg') no-repeat center / 120px auto;
}
.el-container {
  height: 100vh; /* 使容器占满整个视口 */
}

.el-header {
  background-color: #fff;
  color: #333;
  font-size: 20px;
  text-align: left;
  line-height: 60px;
}

.el-aside {
  background-color: #304156;
  height: 100%; /* 侧边栏占据全部高度 */
}

.menu {
  height: 100%; /* 使菜单占据全部侧边栏高度 */
}

.el-main {
  background-color: #f7f8fa;
  color: #333;
  padding: 20px;
}
.el-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}

.non-admin-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f8fa;
  color: #333;
  font-size: 18px;
}
</style>